import { inject } from '@angular/core';
import { Routes } from '@angular/router';
import { AuthService } from '@services/auth/auth.service';
import { NotFoundComponent } from '@shared/pages/not-found/not-found.component';
import { PaymentRequiredComponent } from '@shared/pages/payment-required/payment-required.component';
import publicRoutes from './components/public/public.routes';

export const routes: Routes = [
	{
		// Legacy portal login URL: everyone signs in through the backoffice login now.
		path: 'soporte/login',
		redirectTo: '/login',
		pathMatch: 'full',
	},
	{
		// Standalone client portal (no backoffice chrome). Internal staff use `/tickets`
		// inside the backoffice layout instead (see backoffice.routes.ts).
		path: 'soporte',
		loadChildren: () => import('./components/portal/portal.routes'),
	},
	{
		path: '',
		children: publicRoutes,
	},
	{
		path: '',
		canMatch: [
			() => {
				const token = inject(AuthService).getToken();
				return !!token; // Allow all authenticated users
			},
		],
		loadChildren: () => import('./components/backoffice/backoffice.routes'),
	},
	{
		path: 'account',
		canMatch: [
			() => {
				return !!inject(AuthService).getToken();
			},
		],
		loadChildren: () => import('./components/backoffice/account/account.routes'),
	},
	{
		path: 'payment-required',
		component: PaymentRequiredComponent,
	},
	{
		path: '**',
		component: NotFoundComponent,
	},
];
